import React from "react";

import { Button, Container } from "reactstrap";
import "../../assets/css/HomeHeaders.css";
import Background from "../../assets/images/factory40.jpg";

function HomeHeaders() {
  let pageHeader = React.createRef();
  React.useEffect(() => {
    if (window.innerWidth > 991) {
      const updateScroll = () => {
        let windowScrollTop = window.pageYOffset / 3;
        pageHeader.current.style.transform =
          "translate3d(0," + windowScrollTop + "px,0)";
      };
      window.addEventListener("scroll", updateScroll);
      return function cleanup() {
        window.removeEventListener("scroll", updateScroll);
      };
    }
  });
  return (
    <>
      <div className="page-header page-header-small">
        <div className="page-header-image h-i" ref={pageHeader}></div>
        <div className="content-center">
          <Container>
            <h1 className="title">Créer votre carte de visite en ligne</h1>
            <h3>
              Simple, rapide et efficace ! Votre carte de visite est prêt à
              l'emploi en moins de 10 minutes.
            </h3>
            <div className="text-center">
              <Button
                className="btn-icon btn-round mr-1"
                color="info"
                href="#pablo"
                onClick={(e) => e.preventDefault()}
              >
                <i className="fab fa-facebook-square"></i>
              </Button>
              <Button
                className="btn-icon btn-round mr-1"
                color="info"
                href="#pablo"
                onClick={(e) => e.preventDefault()}
              >
                <i className="fab fa-twitter"></i>
              </Button>
              <Button
                className="btn-icon btn-round"
                color="info"
                href="#pablo"
                onClick={(e) => e.preventDefault()}
              >
                <i className="fab fa-google-plus"></i>
              </Button>
            </div>
          </Container>
        </div>
      </div>
    </>
  );
}

export default HomeHeaders;
